import { Box, Grid, Space } from '@mantine/core';
import { Button } from 'src/components/Button';
import { InputEmail } from 'src/components/Form/Email';
import { InputPassword } from 'src/components/Form/Password';
import { Form } from 'src/form';
import { AuthLayout } from 'src/layouts';

import styles from './styles.module.css';
import { FormData, useLogin } from './use-login';

export const Login = () => {
  const { initialValues, isLoading, onSubmit, subtitle, title, validate } =
    useLogin();

  return (
    <AuthLayout title={title} subtitle={subtitle}>
      <Box className={styles.loginPage}>
        <Form<FormData>
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
          loading={isLoading}
        >
          <Grid gutter={20}>
            <Grid.Col span={12}>
              <InputEmail name="email" label="Email" placeholder="Email" />
            </Grid.Col>
            <Grid.Col span={12}>
              <InputPassword
                name="password"
                label="Password"
                placeholder="Password"
              />
            </Grid.Col>
            {/* <Grid.Col span={12}>
              <Text ta="right">
                <Link className={styles.navLink} to={links.passwordRecovery}>
                  Forgot Password?
                </Link>
              </Text>
            </Grid.Col> */}
            <Grid.Col span={4} offset={4}>
              <Space h="lg" />
              <Button fullWidth round variant="filled" loading={isLoading}>
                SIGN IN
              </Button>
            </Grid.Col>
            {/* <Grid.Col span={12}>
              <Center>
                <Text span className={styles.navLink}>
                  Don't have account? <Link to={links.register}>Sign up</Link>
                </Text>
              </Center>
            </Grid.Col> */}
          </Grid>
        </Form>
      </Box>
    </AuthLayout>
  );
};
